<div class="d-flex align-items-center justify-content-center" *ngIf="imagesArray.length > 0">
    <button mat-button (click)="onClickLeft()" class="secondary-button"><mat-icon>chevron_left</mat-icon></button>
    <div class="slider-container">
        <div class="card-container" #slides >
            <div *ngFor="let image of imagesArray;" style="width: 100%;">
                <mat-card class="example-card mx-2" >
                    <mat-card-content>
                        <img src={{image.value.path}}  height="150px" width="200px" (click)="onShowImage(image.value.path)" style="cursor: pointer;">
                        <p>
                            {{getName(image.key)}}
                        </p>
                        
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
    <button mat-button  (click)="onClickRight()" class="secondary-button"><mat-icon>navigate_next</mat-icon></button>
</div>

<!--
<div class="d-flex align-items-center justify-content-center" *ngIf="sliderImagesArray.length > 0">
    <button mat-button (click)="onClickLeft()" class="secondary-button"><mat-icon>chevron_left</mat-icon></button>
    <div class="slider-container">
        <div class="card-container" #slides >
            <div *ngFor="let image of sliderImagesArray;" style="width: 100%;">
                <mat-card class="example-card mx-2" >
                    <mat-card-content>
                        <img src={{image.response.path}}  height="150px" width="200px" (click)="onShowImage(image.response.path)" style="cursor: pointer;">
                        <p>
                            Fotografía {{image.item.label}}
                        </p>
                        
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
    <button mat-button  (click)="onClickRight()" class="secondary-button"><mat-icon>navigate_next</mat-icon></button>
</div>-->

<app-dialog #showImageDialog [enableCloseDialogButton]="true" height="580px" width="580px" >
    <img src="{{displayImage}}" class="img-fluid">
</app-dialog>
